import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Api from './api';
import * as Actions from './actions';

export const fetchAllObservable = institutionId => {
    return Api.fetchAgeGroups(institutionId).map(({ageGroups, behaviors}) =>
        Actions.fetchAllSuccess.action(ageGroups, institutionId, behaviors),
    );
};

const fetchAllAgeGroups = action$ =>
    action$
        .ofType(Actions.fetchAll.type)
        .mergeMap(({payload}) =>
            fetchAllObservable(payload.institutionId).catch(e => Observable.of(Actions.fetchAllFailed.action(e))),
        );

export const createAgeGroupsObservable = (institutionId, ageGroups) => {
    return Api.createAgeGroups(institutionId, ageGroups).map(ageGroups =>
        Actions.createAllSuccess.action(institutionId, ageGroups),
    );
};

const createAllAgeGroups = action$ =>
    action$
        .ofType(Actions.createAll.type)
        .mergeMap(({payload}) =>
            createAgeGroupsObservable(payload.institutionId, payload.ageGroups).catch(e =>
                Observable.of(Actions.createAllFailed.action(e)),
            ),
        );

export const updateAgeGroupsObservable = (institutionId, ageGroups) => {
    return Api.updateAgeGroups(institutionId, ageGroups).map(ageGroups =>
        Actions.updateAllSuccess.action(institutionId, ageGroups),
    );
};

const updateAllGroups = action$ =>
    action$
        .ofType(Actions.updateAll.type)
        .mergeMap(({payload}) =>
            updateAgeGroupsObservable(payload.institutionId, payload.ageGroups).catch(e =>
                Observable.of(Actions.updateAllFailed.action(e)),
            ),
        );

export default combineEpics(fetchAllAgeGroups, createAllAgeGroups, updateAllGroups);
